import React from 'react'
import styles from './styles.module.css'
import useStore from '../../../../ProductStore/Store'
import uploadIcon from '../../../../../img/uploadSVG.svg'

function SecondRowBoxes () {
  const {
    isQueryLoading,
    setTaxonomy,
    setRawCategory,
    setRequiredFields,
    setPrice,
    setPriceWarranty
  } = useStore()

  const onClickPricingForPetFood = () => {
    if (isQueryLoading) return
    setTaxonomy('pet supplies')
    setRawCategory('food')
    setRequiredFields(['prices'])
  }
  const onClickLLMTrainingData = () => {
    // "query": "categories:* AND description:* AND reviews:*"
    if (isQueryLoading) return
    setRequiredFields(['categories', 'descriptions', 'reviews'])
  }
  const onClickElectronicsPriceRecommendations = () => {
    if (isQueryLoading) return
    setRawCategory('electronics')
    setPrice({ minValue: 100, maxValue: 200, currency: 'USD' })
    setPriceWarranty('true')
  }

  return (
    <section>
    <div className={styles.SecondRowBoxesContainer}>
      {/* <h2 className={styles.SecondRowBoxesTitle}>Search example</h2> */}
      <div className={styles.SecondRowBoxesValues}>
        <div
          className={`${styles.SecondRowBoxesItem} ${
            isQueryLoading ? styles.SecondRowBoxesItemDisabled : ''
          }`}
          onClick={onClickPricingForPetFood}
        >
          <div>
            <span className={styles.SecondRowBoxesSpan}>
              Pricing for pet food
            </span>
            <p className={styles.SecondRowBoxesText}>
              Analytic pricing for pet food
            </p>
          </div>
          <img
            src={uploadIcon}
            alt="upload"
            className={styles.SecondRowBoxesImg}
          />
        </div>
        <div
          className={`${styles.SecondRowBoxesItem} ${
            isQueryLoading ? styles.SecondRowBoxesItemDisabled : ''
          }`}
          onClick={onClickLLMTrainingData}
        >
          <div>
            <span className={styles.SecondRowBoxesSpan}>
              LLM training data
            </span>
            <p className={styles.SecondRowBoxesText}>
              Product data for training LLMs and AI datasets
            </p>
          </div>
          <img
            src={uploadIcon}
            alt="upload"
            className={styles.SecondRowBoxesImg}
          />
        </div>
        <div
          className={`${styles.SecondRowBoxesItem} ${
            isQueryLoading ? styles.SecondRowBoxesItemDisabled : ''
          }`}
          onClick={onClickElectronicsPriceRecommendations}
        >
          <div>
            <span className={styles.SecondRowBoxesSpan}>
              Personalized electronics price recommendations
            </span>
            <p className={styles.SecondRowBoxesText}>
              Provide personalized price recommendations to users.
            </p>
          </div>
          <img
            src={uploadIcon}
            alt="upload"
            className={styles.SecondRowBoxesImg}
          />
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default SecondRowBoxes
